import { GetPurchaseHistoryApiParameter } from "@GeriMed/Services/PurchaseHistoryService";
import { PurchaseHistoryState } from "@GeriMed/Store/Data/PurchaseHistory/PurchaseHistoryState";
import { CustomerDisplayProductCollection } from "@GeriMed/Type/ApiModelsExt";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: PurchaseHistoryState = {
    isLoading: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const reducer = {
    "Data/PurchaseHistory/BeginLoadPurchaseHistory": (
        draft: Draft<PurchaseHistoryState>,
        action: { parameter: GetPurchaseHistoryApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Data/PurchaseHistory/CompleteLoadPurchaseHistory": (
        draft: Draft<PurchaseHistoryState>,
        action: { parameter: GetPurchaseHistoryApiParameter; collection: CustomerDisplayProductCollection },
    ) => {
        setDataViewLoaded(
            draft,
            action.parameter,
            action.collection,
            collection => action.collection.productList,
        );
    },
    "Data/PurchaseHistory/Reset": () => {
        return initialState;
    },
};

const purchasehistoryreducer = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).dataPurchaseHistory = purchasehistoryreducer;
